import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { paths } from '@AppRoutes/constants';
import { Modal } from '@els/els-react--modal';
import { Checkbox } from '@els/els-react--checkbox';
import { Button } from '@els/els-react--button';
import { closeDialog } from '@Containers/Dialogs/DialogsActions';
import Login from '@Services/Login';
import NewRelicService from '@Services/NewRelicService';
import { typeOfLogoutConfirmModal } from './LogoutConfirmModalConstants';

import './LogoutConfirmModal.scss';

// Figma bolds the brand word in the expired body; keep it as inline emphasis rather than SCSS.
const emphasizeReaxys = (text) =>
  typeof text !== 'string'
    ? text
    : text.split(/(Reaxys)/g).map((part, i) =>
        // eslint-disable-next-line react/no-array-index-key
        part === 'Reaxys' ? <b key={i}>{part}</b> : <React.Fragment key={i}>{part}</React.Fragment>
      );

function LogoutConfirmModal({ content = {}, onConfirm = () => {} }) {
  const [remember, setRemember] = useState(false);
  let unsubLocationChangeSuccess;
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    setRemember(content.remember);
    return () => {
      if (unsubLocationChangeSuccess) {
        unsubLocationChangeSuccess();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content.remember]);

  const closeWindow = () => {
    dispatch(
      closeDialog({
        id: typeOfLogoutConfirmModal,
      })
    );
  };
  const confirm = () => {
    onConfirm()
      .then(() => {
        Login.afterLogout(!remember);
        closeWindow();

        NewRelicService.trackRouteChanges('/logout');
        history.push({
          pathname: paths.LOGOUT,
        });
      })
      .catch(Logger.error);
  };
  // Expired flow: the session is already gone, so close/Escape only applies the Remember me
  // choice, completes client cleanup, and returns the user to the Reaxys homepage.
  const closeExpired = () => {
    Login.afterLogout(!remember);
    closeWindow();
    NewRelicService.trackRouteChanges(paths.SEARCH);
    history.replace({
      pathname: paths.SEARCH,
    });
  };
  const handleClose = () => (content.isSessionExpired ? closeExpired() : closeWindow());
  return (
    <Modal
      onClose={handleClose}
      label={content.message}
      width="min(34rem, calc(100vw - 2rem))"
      className="logout-confirm-modal"
      id="logout-confirm"
      shouldPreventClickOverlayToClose>
      <div>
        <h4>{content.message}</h4>
        {content.text && (
          <div className="u-els-margin-top u-els-padding-top-1o4">
            <span>{emphasizeReaxys(content.text)}</span>
          </div>
        )}
        {content.hasRemember && (
          <div className="u-els-margin-top-2x">
            <Checkbox
              data-e2e="logout-remember-me"
              checked={remember}
              onChange={() => {
                setRemember(!remember);
              }}
              label="Remember me on this computer"
            />
          </div>
        )}
        {!content.isSessionExpired && (
          <div className="u-els-margin-top-2x u-els-display-flex o-els-flex-layout--right">
            <Button data-e2e="logout-confirm" type="secondary" onClick={() => confirm()} className="e2e-logout-confirm">
              Sign Out
            </Button>
            <Button
              data-e2e="logout-continue-working"
              onClick={() => closeWindow()}
              className="u-els-margin-left e2e-logout-continue-working">
              Continue Working
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
}

LogoutConfirmModal.propTypes = {
  content: PropTypes.object,
  onConfirm: PropTypes.func,
};

export default LogoutConfirmModal;
